import { ARCHITECTURE_VERSION } from "./systemArchitecture.mjs";

export const SYSTEM_STATE_KEY = "groot-system-state";
export const MIGRATIONS = Object.freeze([
  {
    id: "v1.1.0-architecture-baseline",
    description: "Establish the code-owned architecture version without rewriting operating records.",
    async run() { return { changedStores: [], liveDataRepaired: [] }; },
  },
]);

export async function runSystemMigrations(repository, now = () => new Date().toISOString()) {
  const state = (await repository.getStore(SYSTEM_STATE_KEY)) || { appliedMigrations: [] };
  const applied = new Set(state.appliedMigrations || []), results = [];
  for (const migration of MIGRATIONS) {
    if (applied.has(migration.id)) continue;
    const result = await migration.run(repository);
    applied.add(migration.id);
    results.push({ id: migration.id, ...result });
  }
  const next = { ...state, architectureVersion: ARCHITECTURE_VERSION, appliedMigrations: [...applied], lastMigrationAt: results.length ? now() : state.lastMigrationAt || null };
  if (results.length || state.architectureVersion !== ARCHITECTURE_VERSION) await repository.setStore(SYSTEM_STATE_KEY, next);
  return { state: next, results };
}
